<!-- Toolbar -->
<div class="flex flex-1 flex-row align-items-center column-gap-2 mb-2">
  <medsurf-slide-main-toolbar-title [class]="'w-full'"></medsurf-slide-main-toolbar-title>
</div>
